export default "<p>draggable works!</p>\n"